<template>
  <p class="arbreNavigation" v-if="$route.name !== 'messagerie'">
    <router-link style="color: black; text-decoration: underline;" :to="{ name: 'accueil'}">Accueil</router-link>
    &nbsp;
    <img v-if="filArianeMiddleLabel"
      align="absmiddle"
      border="0"
      alt
      height="6"
      width="3"
      src="../assets/pucette2.gif"
    />
    <a v-if="filArianeMiddleLabel">&nbsp;&nbsp;</a>
    <router-link v-if="filArianeMiddleLabel" style="color: black; text-decoration: underline;" :to="{ name: filArianeMiddleRouterLink}">{{filArianeMiddleLabel}}</router-link>
    &nbsp;
    <img
      align="absmiddle"
      border="0"
      alt
      height="6"
      width="3"
      src="../assets/pucette2.gif"
    />
    &nbsp;
    {{filArianeLabel}}
  </p>
</template>

<script>
export default {
  props: ['filArianeLabel', 'filArianeMiddleLabel', 'filArianeMiddleRouterLink']
}
</script>
